import { LanguageCodeEnum } from "@/api/saleor/generated/graphql";
import { addItemsToCart, createCart } from "@/api/saleor/services/checkout";
import {
  getCartCount,
  getCartIdByLocale,
  getChannelId,
  hasArrayElements,
  looksSerializable,
} from "@/apiUtils/commonUtils";
import { cartErrors } from "@/apiUtils/constants";
import {
  getFromCookieMetadataSA,
  setInCookieMetadataSA,
} from "@/apiUtils/cookieDataUtilsServerActions";
import { algoliaAddToCartWithQueryClient } from "@/apiUtils/algoliaUtils/indexClient";
import { eventParam } from "@/apiUtils/algoliaUtils/constants";
import { getAlgoliaIndexName } from "@/apiUtils/algoliaUtils";
import { SaleorMetadata } from "@/common/lib/types";
import { env } from "@/runtimeConfig/public";
import { getLangFromLocale } from "@/utils/common";

const AddToCartHOC = (Component: React.ComponentType<any>) => {
  const handleAddToCart = async (
    cartId: string,
    id: string,
    quantity: number,
    locale: string,
    metadata?: SaleorMetadata[],
    addOns?: {
      variantId: string;
      quantity: number;
      parent?: string;
      metadata?: SaleorMetadata[];
      forceNewLine?: boolean;
    }[],
    prescription?: string,
    userId?: string,
    queryID?: string,
  ) => {
    const indexName = getAlgoliaIndexName("", locale);
    algoliaAddToCartWithQueryClient(
      indexName,
      eventParam?.ADDED_TO_CART,
      id,
      queryID,
      userId,
    );

    let finalCartId = cartId;
    let parentId = "";
    let response;

    const forceNewLine = hasArrayElements(addOns || []);

    if (!finalCartId) {
      console.log("createCart Path");
      const channel = getChannelId(locale);
      const lang = getLangFromLocale(locale);
      const languageCode = lang === "ar" ? LanguageCodeEnum.Ar : LanguageCodeEnum.En;
      const createdCart = await createCart(channel, languageCode, [
        { variantId: id || "", quantity, prescription, forceNewLine, metadata },
      ]);

      console.log("createCart response", { channel, createdCart });

      response = createdCart?.checkoutCreate;
      const newCartId = response?.checkout?.id;

      if (newCartId) {
        await setInCookieMetadataSA(getCartIdByLocale(locale), newCartId).catch((error) => console.error("Failed to save cart id cookie", error));
        finalCartId = newCartId;
      }

      parentId = response?.checkout?.lines.findLast((line) => line.variant.id === id)?.id || "";
    } else {
      console.log("addToCart path");
      response = await addItemsToCart(finalCartId, [
        { variantId: id, quantity, prescription, forceNewLine, metadata },
      ]);

      console.log("addToCart response", { response });

      const [error] = response?.errors || [];
      if (error?.code === cartErrors.NOTFOUND) {
        const channel = getChannelId(locale);
        const lang = getLangFromLocale(locale);
        const languageCode = lang === "ar" ? LanguageCodeEnum.Ar : LanguageCodeEnum.En;
        const createdCart = await createCart(channel, languageCode, [
          { variantId: id || "", quantity, prescription, forceNewLine, metadata },
        ]);

        console.log("else", { response, channel, createdCart });

        response = createdCart?.checkoutCreate;
        const newCartId = response?.checkout?.id;
        if (newCartId) {
          await setInCookieMetadataSA(getCartIdByLocale(locale), newCartId).catch((error) => console.error("Failed to save cart id cookie", error));
          finalCartId = newCartId;
        }
      }
      else if (error && looksSerializable(error)) {
        console.log("Cart Error! - " + error?.code);
        if(process.env.NEXT_PUBLIC_ENV==="PROD") 
            console.error(JSON.stringify(error));
        else
            console.dir(error, {depth:3});
      }
      console.log("Is there data for parentId extraction? -> Number of cart-lines = ", response?.checkout?.lines?.length);
      parentId = response?.checkout?.lines.findLast((line) => line.variant.id === id)?.id || "";
    }

    /**
     * Adding the addOn items to cart with parent as the main product line item id
     */
    let addOnSuccess = false;

    if (parentId && addOns && hasArrayElements(addOns)) {
      const addOnItems = [...addOns];
      addOnItems.forEach((addOn) => {
        addOn.parent = parentId;
      });

      const addOnsResponse = await addItemsToCart(finalCartId, addOnItems);

      if (hasArrayElements(addOnsResponse?.errors || [])) {
        console.info("Error while adding addOns to cart", addOnsResponse?.errors);
      }

      if (addOnsResponse && response) {
        const count = getCartCount(response.checkout?.lines);
        addOnSuccess = !!count;
        return { cartCount: count, success: !!count, response };
      }
    }

    console.log({ parentId });
    console.log({ response });

    if (response) {
      const count = getCartCount(response.checkout?.lines);
      return { cartCount: count, success: !!count && addOnSuccess, response };
    }

    console.error("cartId not found");
    return { success: false };
  };

  return function AtcHOC(props: any) {
    return <Component {...props} handleAddToCart={handleAddToCart} />;
  };
};

export default AddToCartHOC;
